import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { FormHelperText } from '@material-ui/core';
import FormInputNumberField from './FormInputNumberField';

export default function DateOfBirthInput({
    dateOfBirth,
    setDateOfBirth,
    errorMessage,
    hasError
}) {
    const [month, setMonth] = useState(0);
    const [day, setDay] = useState(0);
    const [year, setYear] = useState(0);
    useEffect(() => {
        setMonth(dateOfBirth.length ? moment(dateOfBirth).month() : 0);
        setDay(dateOfBirth.length ? moment(dateOfBirth).day() : 0);
        setYear(dateOfBirth.length ? moment(dateOfBirth).year() : 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(
        () => {
            if (!month || !day || !year) {
                return;
            }
            const newMonth =
                month.toString().length === 1 ? `0${month}` : month;
            const newDay = day.toString().length === 1 ? `0${day}` : day;
            setDateOfBirth(
                year && month && day ? `${year}-${newMonth}-${newDay}` : ''
            );
        },
        [day, month, year, setDateOfBirth]
    );
    return (
        <div data-testid="date-of-birth-input">
            <h4 className="parental-consent-header">Date of birth</h4>
            <div className="date-of-birth-inputs">
                <div>
                    <FormInputNumberField
                        label="MM"
                        initialValue={month}
                        minValue={1}
                        maxValue={12}
                        maxLength={2}
                        hasError={hasError}
                        onChangeNumber={setMonth}
                    />
                </div>
                <div>
                    <FormInputNumberField
                        label="DD"
                        initialValue={month}
                        minValue={1}
                        maxValue={31}
                        maxLength={2}
                        hasError={hasError}
                        onChangeNumber={setDay}
                    />
                </div>
                <div>
                    <FormInputNumberField
                        label="YYYY"
                        initialValue={month}
                        minValue={1}
                        maxLength={4}
                        hasError={hasError}
                        onChangeNumber={setYear}
                    />
                </div>
            </div>
            {hasError && <FormHelperText error>{errorMessage}</FormHelperText>}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/v5/termsOfUse/components/DateOfBirthInput.js